import { EMISSOR_ORDER_FILTER_STATUS_LABELS, EMISSOR_ORDER_FILTER_STATUS_ORDER } from './types';
export const buildEmissorOrderFiltersSummaryLabel = ({ filters, productOptions, formatCompetence, translate, }) => {
    const statusLabels = EMISSOR_ORDER_FILTER_STATUS_ORDER.filter(status => filters.screenStatuses.includes(status)).map(status => translate(EMISSOR_ORDER_FILTER_STATUS_LABELS[status]));
    const productLabels = productOptions
        .filter(option => filters.productIds.includes(option.id))
        .map(option => option.label);
    const labels = [
        ...(filters.competence ? [formatCompetence(filters.competence)] : []),
        ...statusLabels,
        ...productLabels,
    ];
    if (!labels.length) {
        return null;
    }
    const remainingCount = labels.length - 1;
    return remainingCount > 0 ? `${labels[0]} + ${remainingCount}` : labels[0];
};
